const formatNode = (node) => {
  return {
    ...node,
    amountRaised: node?.amount?.value ?? 0,
  }
}

export const formatFELeaderboards = (leaderboardsData, updateLeaderboards) => {
  const individual = []
  const team = []
  const weekly = []

  const { userLeaderboard, teamLeaderboard, weeklyLeaderboard } =
    leaderboardsData.data.fundraisingEvent

  if (userLeaderboard?.entries?.edges && userLeaderboard.entries.edges.length > 0)
    userLeaderboard.entries.edges.map(({ node }) => individual.push(formatNode(node)))
  if (teamLeaderboard?.entries?.edges && teamLeaderboard.entries.edges.length > 0)
    teamLeaderboard.entries.edges.map(({ node }) => team.push(formatNode(node)))
  if (weeklyLeaderboard?.entries?.edges && weeklyLeaderboard.entries.edges.length > 0)
    weeklyLeaderboard.entries.edges.map(({ node }) => weekly.push(formatNode(node)))

  updateLeaderboards({ individual, team, weekly })
}

export const formatCauseLeaderboards = (leaderboardsData, updateLeaderboards) => {
  const individual = []
  const team = []

  const { userLeaderboard, teamLeaderboard } = leaderboardsData.data.cause

  if (userLeaderboard?.entries?.edges && userLeaderboard.entries.edges.length > 0)
    userLeaderboard.entries.edges.map(({ node }) => individual.push(formatNode(node)))
  if (teamLeaderboard?.entries?.edges && teamLeaderboard.entries.edges.length > 0)
    teamLeaderboard.entries.edges.map(({ node }) => team.push(formatNode(node)))

  updateLeaderboards({ individual, team })
}
